import type { ReactNode } from 'react';

export enum ModalSize {
    small,
    default,
}

export interface Props {
    children: ReactNode;
    title?: ReactNode | string;
    submitText?: ReactNode | string;
    closeText?: ReactNode | string;
    isSubmitDisabled?: boolean;
    hideCloseButton?: boolean;
    onSubmitHandler?: () => void;
    onCloseHandler: () => void;
    size?: ModalSize;
}
